const ptBRJSON = {
  DUPLICATE_OF: 'Duplicado de',
  DUPLICATED_BY: 'Duplicado por',
  RELATED_TO: 'Relacionado a',
  SPLIT_TO: 'Dividido para',
  SPLIT_FROM: 'Dividido de',
  BLOCKED_BY: 'Bloqueado por',
  BLOCKS: 'Bloqueia',
  MORE_THAN: 'Maior que',
  LESS_THAN: 'Menor que',
  OPEN: 'Aberto',
  IN_PROGRESS: 'Em Progresso',
  ON_HOLD: 'Em Espera',
  COMPLETE: 'Concluído',
  'home.built': 'Construído para Facilitar a Gestão de Manutenção',
  home_description:
    'Quando quadros brancos e notas adesivas são caóticos, e você precisa de um software CMMS fácil o suficiente para sua equipe realmente usar - experimente o {{shortBrandName}}',
  try_grash: 'Experimente o {{shortBrandName}}',
  login: 'Entrar',
  start_trial: 'Iniciar um teste gratuito',
  'home.what': 'O que',
  'home.you_will_have': 'Você terá',
  'home.you_will_have_description':
    'Crie fluxos de trabalho eficientes e confiáveis que colocam você no controle da manutenção. Gere, atribua e acompanhe ordens de serviço. Controle o inventário. E obtenha relatórios automatizados confiáveis que melhoram a visibilidade e criam responsabilidade.',
  key_features: 'Recursos Principais',
  key_features_description:
    'Alguns dos recursos que tornam o {{shortBrandName}} um dos melhores CMMS disponíveis hoje',
  contribute: 'Contribuir',
  work_orders: 'Ordens de Serviço',
  request_system: 'Sistema de Solicitação de Trabalho',
  mobile_app: 'Aplicativo Móvel',
  asset_management: 'Gestão de Ativos',
  preventive_maintenance: 'Manutenção Preventiva',
  parts_inventory: 'Inventário de Peças',
  custom_dashboards: 'Painéis Personalizados',
  'work-orders.title': 'Gerencie suas Ordens de Serviço como um Chefe',
  'work-orders.description.short': 'Visualize e gerencie todas as suas tarefas',
  'work-orders.descriptions.0':
    'Cansado da papelada e das ordens de serviço perdidas? Todos esses itens perdidos afetam diretamente o resultado final e sua reputação.',
  'work-orders.descriptions.1':
    'Com o {{shortBrandName}}, você pode organizar facilmente todas as suas ordens de serviço, PMs e outras tarefas em um banco de dados centralizado que pode ser acessado em qualquer dispositivo.',
  'work-orders.checks.0':
    'Visualize todas as suas tarefas, incluindo OS, PMs e solicitações de trabalho.',
  'work-orders.checks.1':
    'Defina a prioridade da tarefa para que o trabalho certo seja feito primeiro.',
  'work-orders.checks.2':
    'Visualize um calendário de tarefas atuais e futuras.',
  'work-orders.checks.3':
    'Visualize atribuições de trabalho com informações críticas, como informações do ativo, data de vencimento, prioridade e mais.',
  'work-orders.checks.4':
    'Visualize KPIs críticos, como trabalho concluído, tempo gasto e trabalho planejado vs. não planejado.',

  'work-requests.title':
    'Um sistema de solicitação de trabalho móvel simplificado',
  'work-requests.descriptions.0':
    'Cansado de usar o antigo sistema de telefone e e-mail que resulta em tickets PERDIDOS, interrupções diárias constantes e trabalho duplicado?',
  'work-requests.descriptions.1':
    'A solução de gerenciamento de manutenção do {{shortBrandName}} permite que qualquer pessoa autorizada envie um problema para o departamento de manutenção simplesmente escaneando um código QR (código de barras) ou visitando uma URL e digitando sua solicitação através de seus dispositivos móveis.',
  'work-requests.checks.0': 'Nunca mais perca trabalho.',
  'work-requests.checks.1':
    'Reduza o tempo gasto com solicitações de trabalho em até 34%.',
  'work-requests.checks.2':
    'Reduza o tempo de comunicação com os solicitantes em até 41% (chamadas, e-mails, textos).',

  'mobile-app.title':
    'Um aplicativo móvel CMMS que capacita sua equipe de manutenção',
  'mobile-app.descriptions.0':
    'Através do uso de nossos aplicativos móveis Android e IOS, nossos clientes experimentam melhor organização, comunicação, responsabilidade e produtividade em até 30% em toda a equipe de manutenção.',
  'mobile-app.descriptions.1':
    'A partir de seu dispositivo móvel, qualquer membro da sua equipe de manutenção pode:',
  'mobile-app.checks.0': 'Visualizar suas ordens de serviço e PMs atribuídos.',
  'mobile-app.checks.1':
    'Registrar suas ordens de serviço em menos de 60 segundos.',
  'mobile-app.checks.2':
    'Receber comunicações instantâneas via notificações push e e-mail.',
  'mobile-app.checks.3':
    'Iniciar novas ordens de serviço enquanto está em campo.',
  'mobile-app.checks.4':
    'Responder e registrar problemas enquanto trabalha no problema.',
  'mobile-app.checks.5':
    'Consultar informações críticas do ativo enquanto diagnostica um problema.',

  'eam.title': 'Gestão de Ativos Empresariais',
  'eam.description.short': 'Conheça seus ativos',
  'eam.descriptions.0':
    'Frustrado ao tentar organizar a bagunça caótica dos equipamentos da empresa, sem saber se o equipamento foi devidamente cuidado, sem saber o custo de manutenção e todas as outras dores de cabeça que vêm com a gestão de ativos?',
  'eam.descriptions.1':
    'O módulo de Gestão de Ativos Empresariais do {{brandName}} pode ser usado para entre 10 e 1.000.000 de ativos, permitindo que você rastreie exatamente o que deseja, da maneira que deseja, em uma estrutura de árvore fácil de usar e pesquisável.',
  'eam.checks.0':
    'Conheça a saúde dos seus ativos a qualquer momento e o que eles estão custando.',
  'eam.checks.1': 'Visualize registros de manutenção completos e detalhados.',
  'eam.checks.2':
    'Acompanhe apenas o que deseja com campos personalizados ilimitados.',
  'eam.checks.3':
    'Organize seus ativos em uma hierarquia clara de pai para filho.',
  'eam.checks.4':
    'Encontre informações rapidamente e facilmente com códigos QR (códigos de barras).',
  'eam.checks.5':
    'Receba dados de ativos em tempo real com conectividade de sensores.',

  'pm.title': 'Um Programa Eficaz de Manutenção Preventiva',
  'pm.descriptions.0':
    'Pare de desperdiçar horas preciosas distribuindo manualmente listas de verificação de PM e acompanhando sua equipe para garantir que o trabalho seja feito.',
  'pm.descriptions.1':
    'O {{shortBrandName}} permite que você automatize facilmente o agendamento de PMs para que o trabalho certo seja entregue automaticamente no momento certo para o técnico certo no ativo certo.',
  'pm.checks.0':
    'Automatize o agendamento de PMs para ser diário, semanal, mensal, anual ou baseado em eventos ou leituras de medidores.',
  'pm.checks.1':
    'Notificações automáticas por push e e-mail quando um PM é criado ou vencido.',
  'pm.checks.2':
    'Nosso calendário fácil de usar permite que você visualize todo o trabalho aberto e os agendamentos de PMs futuros.',
  'pm.checks.3': 'Arraste e solte para alterar a data de vencimento.',
  'pm.checks.4':
    'Após a conclusão do PM, o trabalho é automaticamente registrado no registro de manutenção do ativo.',
  'pm.checks.5': 'Requer pouco ou nenhum treinamento para usar.',

  'part.title': 'Controle seu Inventário de Peças de Reposição',
  'part.description.short': 'Saiba quando suas peças vão acabar',
  'part.descriptions.0':
    'Não tem certeza de quais peças você tem em estoque ou onde estão sendo usadas? Não sabe quando suas peças vão acabar ou se seus técnicos terão as peças necessárias para fazer seus trabalhos?',
  'part.descriptions.1':
    'Projetamos o gerenciamento de peças do {{shortBrandName}} para resolver esses problemas e muito mais:',
  'part.checks.0':
    'Receba notificações instantâneas por push e e-mail quando a quantidade de uma peça estiver baixa. Mantenha o número certo de peças em estoque recebendo notificações instantâneas e automáticas por push/e-mail quando a quantidade de uma peça estiver abaixo de um limite personalizado.',
  'part.checks.1':
    'Os técnicos sabem instantaneamente se a peça está em estoque a partir de uma ordem de serviço. Se a peça não estiver em estoque, verifique facilmente outros locais para ver se está disponível.',
  'part.checks.2':
    'Acompanhamento automático do uso de peças. Conforme as ordens de serviço ou PMs usam peças, o inventário será automaticamente atualizado para refletir as peças usadas.',
  'part.checks.3':
    'Saiba o uso da peça. Visualize o registro de peças para ver onde a peça está sendo usada e por quem.',
  'part.checks.4':
    'Elimine peças não utilizadas. Saiba quando uma peça ficou obsoleta.',
  'part.checks.5':
    'Relatórios em tempo real. Saiba quais peças são usadas onde e quanto estão custando.',
  'part.checks.6':
    'Otimize os níveis de estoque. Visualize instantaneamente a previsão de uma peça para ver quantas peças podem ser usadas no próximo ano.',
  'part.checks.7':
    'Consulta de código de barras. Torne seu inventário fácil de rastrear e acessar com códigos QR personalizados.',

  'dashboard.title': 'Seus dados, do seu jeito, com painéis personalizados',
  'dashboard.descriptions.0':
    'Vamos encarar, o primeiro passo para melhorar suas operações é conhecer o bom, o ruim e o feio.',
  'dashboard.descriptions.1':
    'Com os Painéis Personalizados do {{shortBrandName}}, você pode finalmente começar a entender o nefasto "buraco negro da manutenção" e começar a colocar planos baseados em dados em ação, resultando em redução de custos de mão de obra, diminuição do tempo de inatividade e muito mais.',
  'dashboard.descriptions.2':
    'Com os Painéis Personalizados do {{shortBrandName}}, você poderá...',
  'dashboard.checks.0': 'Saber onde seu dinheiro está sendo gasto e por quê.',
  'dashboard.checks.1': 'Saber qual ativo está custando mais e por quê.',
  'dashboard.checks.2': 'Crie seus próprios KPIs personalizados.',
  'dashboard.checks.3':
    'Visualize relatórios que são gerados e atualizados automaticamente com base em suas métricas.',
  'dashboard.checks.4':
    'Visualize relatórios que são facilmente compartilhados via planilhas Excel, PDFs ou dentro do {{shortBrandName}}.',
  'dashboard.checks.5': 'E muito mais...',
  'home.smarter': 'Mais Inteligente',
  'home.work': 'Trabalho',
  'home.smarter_description':
    'O {{shortBrandName}} torna incrivelmente fácil para os técnicos trabalharem com eficiência, dando-lhes acesso às ferramentas e dados de que precisam para realizar o trabalho - tudo na palma da mão.',
  leading_maintenance:
    'Liderando o Caminho para um Futuro Melhor na Manutenção e Confiabilidade',
  //register
  premium_included: 'Recursos premium incluídos',
  no_credit_card: 'Nenhum cartão de crédito necessário',
  perfect_tool: 'A ferramenta perfeita para equipes de manutenção',
  start_trial_today: 'Comece seu teste gratuito hoje',
  create_account: 'Criar conta',
  signup_description:
    'Preencha os campos abaixo para se inscrever em uma conta.',
  account_already: 'Já tem uma conta?',
  signin_here: 'Entre aqui',
  invalid_email: 'O e-mail fornecido deve ser um endereço de e-mail válido',
  required_email: 'O campo de e-mail é obrigatório',
  required_firstName: 'O campo do nome é obrigatório',
  required_lastName: 'O campo do sobrenome é obrigatório',
  required_company: 'O campo do nome da empresa é obrigatório',
  required_employeesCount: 'Forneça o número de funcionários',
  invalid_phone: 'O número de telefone é inválido',
  required_password: 'O campo de senha é obrigatório',
  required_terms: 'Você deve concordar com nossos termos e condições',
  verify_email: 'Por favor, verifique seu e-mail para ativar sua conta',
  registration_error: 'O registro não foi bem-sucedido',
  first_name: 'Nome',
  last_name: 'Sobrenome',
  email: 'Endereço de e-mail',
  phone: 'Telefone',
  password: 'Senha',
  companyName: 'Nome da Empresa',
  employeesCount: 'Número de Funcionários',
  i_accept: 'Eu aceito os',
  terms_conditions: 'termos e condições',
  create_your_account: 'Crie sua conta',
  register: 'Registrar',
  //signin
  login_description: 'Preencha os campos abaixo para entrar em sua conta.',
  no_account_yet: 'Ainda não tem uma conta?',
  signup_here: 'Inscreva-se aqui',
  wrong_credentials: 'Credenciais incorretas fornecidas',
  lost_password: 'Perdeu a senha?',
  //work-orders
  link_wo: 'Vincular Ordens de Serviço',
  link_wo_description: 'Crie relações entre ordens de serviço',
  required_relationType: 'Por favor, selecione o tipo de relação.',
  required_wo: 'O campo de Ordem de Serviço é obrigatório.',
  this_wo: 'Esta Ordem de Serviço',
  the_wo: 'A Ordem de Serviço',
  link: 'Vincular',
  cost_description: 'Descrição do Custo',
  assigned_to: 'Atribuído a',
  category: 'Categoria',
  date: 'Data',
  cost: 'Custo',
  include_cost: 'Incluir este custo no custo total',
  include_cost_description:
    'Isso adicionará o custo ao custo total gasto na Ordem de Serviço',
  required_cost_description: 'A descrição do custo é obrigatória',
  required_cost: 'O custo é obrigatório',
  add_cost: 'Adicionar Custo Adicional',
  add_cost_description:
    'Preencha os campos abaixo para criar e adicionar um custo adicional',
  add: 'Adicionar',
  hourly_rate: 'Taxa Horária',
  include_time: 'Incluir este tempo no tempo total',
  include_time_description:
    'Isso adicionará a duração ao tempo total gasto na Ordem de Serviço',
  work_started_at: 'Trabalho Iniciado em',
  duration: 'Duração',
  hours: 'Horas',
  minutes: 'Minutos',
  required_hours: 'O campo de horas é obrigatório',
  required_minutes: 'O campo de minutos é obrigatório',
  add_time: 'Adicionar Tempo',
  add_time_description:
    'Preencha os campos abaixo para criar e adicionar tempo',
  feedback: 'Feedback',
  feedback_description: 'Dê seu feedback',
  required_feedback: 'O feedback é obrigatório',
  signature: 'Assinatura',
  required_signature: 'A imagem é obrigatória',
  close_wo: 'Fechar Ordem de Serviço',
  close: 'Fechar',
  task_update_success: 'Tarefa atualizada com sucesso',
  task_update_failure: 'A tarefa não pôde ser atualizada',
  notes_save_success: 'Notas salvas com sucesso',
  images_add_task_success: 'As imagens foram adicionadas à tarefa',
  images_add_task_failure: 'Algo deu errado',
  images: 'Imagens',
  required_images: 'Por favor, faça o upload de pelo menos uma imagem',
  add_images: 'Adicionar Imagens',
  tasks: 'Tarefas',
  wo_archive_success: 'A Ordem de Serviço foi arquivada',
  wo_archive_failure: 'A Ordem de Serviço não pôde ser arquivada',
  wo_archive_confirm:
    'Tem certeza de que deseja arquivar esta Ordem de Serviço?',
  quantity_change_success: 'Quantidade alterada com sucesso',
  quantity_change_failure: 'A quantidade não pôde ser alterada',
  details: 'Detalhes',
  updates: 'Atualizações',
  id: 'ID',
  due_date: 'Data de Vencimento',
  location: 'Localização',
  asset: 'Ativo',
  team: 'Equipe',
  created_at: 'Data de criação',
  list_view: 'Visualização em Lista',
  calendar_view: 'Visualização em Calendário',
  column_view: 'Visualização em Coluna',
  wo_create_success: 'A Ordem de Serviço foi criada com sucesso',
  wo_create_failure: 'A Ordem de Serviço não pôde ser criada',
  changes_saved_success: 'As alterações foram salvas',
  wo_update_failure: 'A Ordem de Serviço não pôde ser editada',
  wo_delete_success: 'A Ordem de Serviço foi excluída com sucesso',
  wo_delete_failure: 'A Ordem de Serviço não pôde ser excluída',
  status: 'Status',
  title: 'Título',
  priority: 'Prioridade',
  description: 'Descrição',
  worker: 'Trabalhador',
  location_name: 'Nome do Local',
  location_address: 'Endereço do Local',
  asset_name: 'Nome do Ativo',
  days_since_creation: 'Dias desde a criação',
  files: 'Arquivos',
  requested_by: 'Solicitado por',
  completed_on: 'Concluído em',
  updated_at: 'Atualizado em',
  work_order: 'Ordem de Serviço',
  timer_running: 'Temporizador em execução',
  run_timer: 'Executar Temporizador',
  approved_by: 'Aprovado por',
  created_by: 'Criado por',
  completed_by: 'Concluído por',
  time: 'Tempo',
  save: 'Salvar',
  customers: 'Contratantes',
  no_labor:
    'Nenhum custo de mão de obra foi adicionado ainda. Eles aparecerão aqui quando um usuário registrar o tempo e tiver uma taxa horária armazenada no {{shortBrandName}}.',
  not_assigned: 'Não Atribuído',
  no_additional_cost: 'Nenhum custo adicional foi adicionado ainda',
  parts: 'Peças',
  links: 'Links',
  confirm_delete_file_wo:
    'Tem certeza de que deseja remover este arquivo desta Ordem de Serviço?',
  archive: 'Arquivar',
  labors: 'Mão de Obra',
  add_additional_cost: 'Adicionar Custo Adicional',
  additional_costs: 'Custos Adicionais',
  add_parts: 'Adicionar Peças',
  'wo.title_description': 'Insira o título da Ordem de Serviço',
  image: 'Imagem',
  estimated_duration: 'Duração Estimada em Horas',
  primary_worker: 'Trabalhador Principal',
  additional_workers: 'Trabalhadores Adicionais',
  select_team: 'Selecionar equipe',
  select_location: 'Selecionar localização',
  select_asset: 'Selecionar ativo',
  select_tasks: 'Selecionar Tarefas',
  requires_signature: 'Requer Assinatura',
  required_wo_title: 'O título da Ordem de Serviço é obrigatório',
  add_wo: 'Adicionar Ordem de Serviço',
  add_wo_description:
    'Preencha os campos abaixo para criar e adicionar uma nova Ordem de Serviço',
  edit_wo: 'Editar Ordem de Serviço',
  edit_wo_description:
    'Preencha os campos abaixo para atualizar a Ordem de Serviço',
  'noRows.wo.message':
    'Ordens de Serviço são tarefas ou trabalhos que podem ser agendados ou atribuídos a alguém',
  'noRows.wo.action': "Pressione o botão '+' para criar uma Ordem de Serviço",
  to_delete: 'Excluir',
  confirm_delete_wo: 'Tem certeza de que deseja excluir esta Ordem de Serviço?',
  no_access_wo:
    'Você não tem acesso a Ordens de Serviço. Entre em contato com seu administrador se deveria ter acesso',
  cancel: 'Cancelar',
  select_parts: 'Selecionar Peças',
  sets_of_parts: 'Conjuntos de Peças',
  //preventive maintenance
  paused: 'Pausado',
  trigger_details: 'Detalhes do Gatilho',
  starts_on: 'Começa em',
  ends_on: 'Termina em',
  frequency: 'Frequência',
  every_frequency_days: 'A cada {{frequency}} dias',
  wo_details: 'Detalhes da Ordem de Serviço',
  confirm_delete_file: 'Tem certeza de que deseja remover este arquivo?',
  wo_schedule_success: 'Ordem de Serviço agendada com sucesso',
  wo_schedule_failure: 'A Ordem de Serviço não pôde ser agendada',
  wo_trigger_edit_failure: 'O gatilho da Ordem de Serviço não pôde ser editado',
  wo_trigger_delete_success:
    'O gatilho da Ordem de Serviço foi excluído com sucesso',
  wo_trigger_delete_failure:
    'O gatilho da Ordem de Serviço não pôde ser excluído',
  name: 'Nome',
  wo_title: 'Título da Ordem de Serviço',
  next_wo: 'Próxima Ordem de Serviço',
  trigger_name: 'Nome do Gatilho',
  enter_trigger_name: 'Insira o nome do gatilho',
  frequency_description: 'Frequência em dias',
  wo_configuration: 'Configuração da Ordem de Serviço',
  required_trigger_name: 'O nome do gatilho é obrigatório',
  required_frequency: 'A frequência do gatilho é obrigatória',
  invalid_frequency: 'A frequência deve ser superior a 0',
  schedule_wo: 'Agendar Ordem de Serviço',
  schedule_wo_description:
    'Preencha os campos abaixo para agendar uma Ordem de Serviço',
  edit_wo_trigger: 'Editar Gatilho de Ordem de Serviço',
  edit_wo_trigger_description:
    'Preencha os campos abaixo para editar o gatilho da Ordem de Serviço',
  create_trigger: 'Criar Gatilho',
  'noRows.pm.message': 'Agende Ordens de Serviço com gatilhos personalizados',
  'noRows.pm.action': "Pressione o botão '+' para criar um gatilho",
  confirm_delete_pm:
    'Tem certeza de que deseja excluir este Gatilho de Ordem de Serviço?',
  no_access_pm:
    'Você não tem acesso à seção de Manutenção Preventiva. Entre em contato com seu administrador se deveria ter acesso',
  enter_wo_title: 'Insira o título da Ordem de Serviço',
  //menuItems
  status_report: 'Relatório de Status',
  wo_analysis: 'Análise de Ordens de Serviço',
  wo_aging: 'Envelhecimento de Ordens de Serviço',
  time_and_cost: 'Tempo e Custo',
  assets: 'Ativos',
  reliability_dashboard: 'Painel de Confiabilidade',
  total_maintenance_cost: 'Custo Total de Manutenção',
  useful_life: 'Vida Útil',
  requests: 'Solicitações',
  locations: 'Localizações',
  parts_and_inventory: 'Peças/Inventário',
  purchase_orders: 'Ordens de Compra',
  meters: 'Medidores',
  people_teams: 'Pessoas e Equipes',
  people: 'Pessoas',
  teams: 'Equipes',
  vendors_customers: 'Fornecedores e Contratantes',
  vendors: 'Fornecedores',
  categories: 'Categorias',
  settings: 'Configurações',
  //request
  cancelled: 'Cancelado',
  reject: 'Rejeitar',
  approve: 'Aprovar',
  request_create_success: 'Solicitação de Ordem de Serviço criada com sucesso',
  request_create_failure:
    'A Solicitação de Ordem de Serviço não pôde ser criada',
  request_edit_failure: 'A Solicitação não pôde ser editada',
  request_delete_success: 'A Solicitação foi excluída com sucesso',
  request_delete_failure: 'A Solicitação não pôde ser excluída',
  rejected: 'Rejeitado',
  approved: 'Aprovado',
  pending: 'Pendente',
  required_request_name: 'O título da solicitação é obrigatório',
  required_field: 'Este campo é obrigatório',
  add_request: 'Adicionar Solicitação',
  add_request_description:
    'Preencha os campos abaixo para criar e adicionar uma nova Solicitação',
  edit_request: 'Editar Solicitação',
  edit_request_description:
    'Preencha os campos abaixo para editar a Solicitação',
  'noRows.request.message': 'Gerencie suas Solicitações de Trabalho',
  'noRows.request.action':
    "Pressione o botão '+' para criar uma Solicitação de Trabalho",
  confirm_delete_request: 'Tem certeza de que deseja excluir esta Solicitação?',
  request: 'Solicitação',
  request_details: 'Detalhes da Solicitação',
  none_priority: 'Nenhum',
  low_priority: 'Baixo',
  medium_priority: 'Médio',
  high_priority: 'Alto',
  //asset
  downtimes: 'Tempos de Inatividade',
  confirm_delete_file_asset:
    'Tem certeza de que deseja remover este Arquivo deste ativo?',
  actions: 'Ações',
  show: 'Mostrar',
  model: 'Modelo',
  serial_number: 'Número de Série',
  operational: 'Operacional',
  down: 'Inoperante',
  area: 'Área',
  barcode: 'Código de Barras',
  placed_in_service: 'Colocado em Serviço',
  warranty_expiration: 'Expiração da Garantia',
  asset_information: 'Informações do Ativo',
  more_informations: 'Mais Informações',
  confirm_delete_asset_downtime:
    'Tem certeza de que deseja remover este Tempo de Inatividade?',
  create_downtime_success: 'O Tempo de Inatividade foi adicionado com sucesso',
  create_downtime_failure: 'O Tempo de Inatividade não pôde ser adicionado',
  edit_downtime_success: 'O Tempo de Inatividade foi editado com sucesso',
  started_on: 'Iniciado em',
  required_startsOn: 'A data de início é obrigatória',
  reading_create_success: 'A Leitura foi adicionada com sucesso',
  reading_create_failure: 'A Leitura não pôde ser adicionada',
  reading: 'Leitura',
  added_by: 'Adicionado por',
  enter_meter_value: 'Insira o valor do medidor',
  add_reading: 'Adicionar Leitura',
  select_meter: 'Selecionar Medidor',
  confirm_delete_part_asset:
    'Tem certeza de que deseja remover esta Peça deste ativo?',
  no_due_date: 'Sem Data de Vencimento',
  due_at_date: 'Vencimento em {{date}}',
  no_primary_worker: 'Nenhum Trabalhador Principal',
  no_wo_linked_asset: 'Não há Ordem de Serviço vinculada a este Ativo',
  asset_remove_success: 'O Ativo foi excluído com sucesso',
  asset_remove_failure: 'O Ativo não pôde ser excluído',
  asset_name_description: 'Insira o nome do ativo',
  select_asset_location: 'Selecionar localização do ativo',
  primary_user_description: 'Selecionar usuário principal',
  teams_description: 'Selecionar equipes',
  customers_description: 'Selecionar contratantes',
  vendors_description: 'Selecionar fornecedores',
  inServiceDate_description: 'Data de colocação em serviço',
  warranty_expiration_date: 'Data de expiração da garantia',
  additional_information: 'Informações Adicionais',
  structure: 'Estrutura',
  parent_asset: 'Ativo Pai',
  asset_create_success: 'O Ativo foi criado com sucesso',
  asset_create_failure: 'O Ativo não pôde ser criado',
  additional_workers_description: 'Selecionar trabalhadores adicionais',
  required_asset_name: 'O nome do ativo é obrigatório',
  add_asset: 'Adicionar Ativo',
  add_asset_description:
    'Preencha os campos abaixo para criar e adicionar um novo ativo',
  create_asset: 'Criar Ativo',
  hierarchy: 'Hierarquia',
  add_downtime: 'Adicionar Tempo de Inatividade',
  edit_downtime: 'Editar Tempo de Inatividade',
  remove_downtime: 'Remover Tempo de Inatividade',
  edit: 'Editar',
  edit_asset: 'Editar Ativo',
  edit_asset_description: 'Preencha os campos abaixo para editar este ativo',
  confirm_delete_asset: 'Tem certeza de que deseja excluir este Ativo?',
  loading_assets: 'Carregando ativos sob {{name}} #{{id}}',
  no_content: 'Sem Conteúdo',
  no_result_criteria:
    'Nenhum resultado corresponde aos seus critérios de pesquisa',
  //location
  map_view: 'Visualização do Mapa',
  location_create_success: 'A localização foi criada com sucesso',
  location_create_failure: 'A localização não pôde ser criada',
  location_edit_failure: 'A localização não pôde ser editada',
  location_delete_success: 'A localização foi excluída com sucesso',
  location_delete_failure: 'A localização não pôde ser excluída',
  enter_location_name: 'Insira o nome da localização',
  address: 'Endereço',
  parent_location: 'Localização Pai',
  select_workers: 'Selecionar Trabalhadores',
  map_coordinates: 'Coordenadas do Mapa',
  required_location_name: 'O título da localização é obrigatório',
  required_location_address: 'O endereço da localização é obrigatório',
  add_location: 'Adicionar localização',
  add_location_description:
    'Preencha os campos abaixo para criar e adicionar uma nova localização',
  edit_location: 'Editar localização',
  edit_location_description:
    'Preencha os campos abaixo para atualizar a localização',
  confirm_delete_location:
    'Tem certeza de que deseja excluir esta Localização?',
  floor_plans: 'Plantas Baixas',
  floor_plan: 'Planta Baixa',
  floor_plan_name_description: 'Nome da planta baixa',
  'Floor plan area in m²': 'Área da planta baixa em m²',
  upload_image: 'Carregar uma imagem',
  required_floor_plan_name: 'O nome da planta baixa é obrigatório',
  add_floor_plan: 'Adicionar nova Planta Baixa',
  add_floor_plan_description:
    'Preencha os campos abaixo para criar uma nova Planta Baixa',
  no_asset_in_location: 'Nenhum ativo nesta localização',
  no_wo_in_location: 'Nenhuma Ordem de Serviço nesta localização',
  no_file_in_location: 'Nenhum arquivo anexado a esta localização',
  no_floor_plan_in_location: 'Nenhuma Planta Baixa nesta localização',
  assigned_teams: 'Equipes Atribuídas',
  assigned_customers: 'Contratantes Atribuídos',
  assigned_vendors: 'Fornecedores Atribuídos',
  //no_access
  no_access_location:
    'Você não tem acesso a Localizações. Entre em contato com seu administrador se deveria ter acesso',
  no_access_vendors_customers:
    'Você não tem acesso a Fornecedores e Contratantes. Entre em contato com seu administrador se deveria ter acesso',
  no_access_people_team:
    'Você não tem acesso a Pessoas e Equipes. Entre em contato com seu administrador se deveria ter acesso',
  no_access_analytics:
    'Você não tem acesso a Análises. Entre em contato com seu administrador se deveria ter acesso',
  no_access_assets:
    'Você não tem acesso a Ativos. Entre em contato com seu administrador se deveria ter acesso',
  no_access_categories:
    'Você não tem acesso a Categorias. Entre em contato com seu administrador se deveria ter acesso',
  no_access_files:
    'Você não tem acesso a Arquivos. Entre em contato com seu administrador se deveria ter acesso',
  no_access_inventory:
    'Você não tem acesso ao Inventário. Entre em contato com seu administrador se deveria ter acesso',
  no_access_meters:
    'Você não tem acesso a Medidores. Entre em contato com seu administrador se deveria ter acesso',
  no_access_purchase_orders:
    'Você não pode criar uma Ordem de Compra. Entre em contato com seu administrador se deveria ter acesso',
  no_access_requests:
    'Você não tem acesso a Solicitações. Entre em contato com seu administrador se deveria ter acesso',
  no_access_settings:
    'Você não tem acesso às configurações. Entre em contato com seu administrador se deveria ter acesso',
  no_access_page: 'Você não tem acesso a esta página',
  file: 'Arquivo',
  'noRows.location.message':
    'Localizações permitem que você gerencie ativos e trabalhadores de forma mais eficiente',
  'noRows.location.action': "Pressione o botão '+' para criar uma Localização",
  //inventory
  card_view: 'Visualização em Cartão',
  set_create_success: 'O Conjunto foi criado com sucesso',
  set_create_failure: 'O Conjunto não pôde ser criado',
  set_edit_failure: 'O Conjunto não pôde ser editado',
  set_delete_success: 'O Conjunto foi excluído com sucesso',
  set_delete_failure: 'O Conjunto não pôde ser excluído',
  total_cost: 'Custo Total',
  part: 'Peça',
  enter_part_name: 'Insira o nome da peça',
  required_set_name: 'O nome do conjunto é obrigatório',
  add_set: 'Adicionar Conjunto',
  add_set_description:
    'Preencha os campos abaixo para criar e adicionar um novo Conjunto',
  create_set: 'Criar Conjunto',
  edit_set: 'Editar Conjunto',
  edit_set_description: 'Preencha os campos abaixo para editar o Conjunto',
  confirm_delete_set: 'Tem certeza de que deseja excluir este Conjunto?',
  part_create_success: 'A Peça foi criada com sucesso',
  part_create_failure: 'A Peça não pôde ser criada',
  part_edit_failure: 'A Peça não pôde ser editada',
  part_delete_success: 'A Peça foi excluída com sucesso',
  part_delete_failure: 'A Peça não pôde ser excluída',
  quantity: 'Quantidade',
  open_wo: 'Ordens de Serviço Abertas',
  enter_part_category: 'Insira a categoria da peça',
  enter_part_cost: 'Insira o custo da peça',
  enter_part_quantity: 'Insira a quantidade da peça',
  minimum_quantity: 'Quantidade Mínima',
  enter_part_minimum_quantity: 'Insira a quantidade mínima da peça',
  non_stock: 'Sem Estoque',
  enter_part_barcode: 'Insira o código de barras da peça',
  enter_part_area: 'Insira a área da peça',
  additional_part_details: 'Detalhes Adicionais da Peça',
  add_part: 'Adicionar Peça',
  add_part_description:
    'Preencha os campos abaixo para criar e adicionar uma nova Peça',
  create_part: 'Criar Peça',
  update_part: 'Atualizar Peça',
  update_part_description: 'Preencha os campos abaixo para atualizar a Peça',
  'noRows.part.message':
    'Peças podem ser combinadas em ativos ou usadas sozinhas',
  'noRows.part.action': "Pressione o botão '+' para criar uma Peça",
  confirm_delete_part: 'Tem certeza de que deseja excluir esta Peça?',
  part_details: 'Detalhes da Peça',
  area_details: 'Detalhes da Área',
  assigned_people: 'Pessoas Atribuídas',
  no_asset_related_part: 'Nenhum ativo relacionado a esta peça',
  no_file_found: 'Nenhum arquivo encontrado',
  no_wo_found: 'Nenhuma Ordem de Serviço encontrada',
  workers: 'Trabalhadores',
  Parts_and_Inventory: 'Peças e Inventário',
  //purchase order
  po_edit_failure: 'A Ordem de Compra não pôde ser editada',
  po_delete_success: 'A Ordem de Compra foi excluída com sucesso',
  po_delete_failure: 'A Ordem de Compra não pôde ser excluída',
  number_of_items: 'Número de Itens',
  total_quantity: 'Quantidade Total',
  shipping_to: 'Enviar para',
  shipping_address: 'Endereço de Envio',
  po_details: 'Detalhes da Ordem de Compra',
  enter_po_name: 'Insira o nome da Ordem de Compra',
  additional_details: 'Detalhes Adicionais',
  vendor: 'Fornecedor',
  shipping_information: 'Informações de Envio',
  company_name: 'Nome da Empresa',
  ship_to: 'Enviar para',
  city: 'Cidade',
  state: 'Estado',
  zip_code: 'CEP',
  fax_number: 'Número de Fax',
  po_date: 'Data da Ordem de Compra',
  notes: 'Notas',
  add_notes: 'Adicionar Notas',
  requisitioner: 'Requisitante',
  terms: 'Termos',
  shipping_method: 'Método de Envio',
  required_name: 'O nome é obrigatório',
  edit_po: 'Editar Ordem de Compra',
  edit_po_description:
    'Preencha os campos abaixo para atualizar a Ordem de Compra',
  purchase_order: 'Ordem de Compra',
  'noRows.po.message': 'Gerencie suas Ordens de Compra em um único lugar',
  'noRows.po.action': "Pressione o botão '+' para criar uma Ordem de Compra.",
  confirm_delete_po: 'Tem certeza de que deseja excluir esta Ordem de Compra?',
  upgrade_po: 'Atualize para criar Ordens de Compra',
  new_po: 'Nova Ordem de Compra',
  po_create_success: 'A Ordem de Compra foi criada com sucesso',
  select_one_part: 'Selecione pelo menos 1 peça',
  po_create_failure: 'A Ordem de Compra não pôde ser criada',
  approve_while_submitting: 'Aprovar ao enviar',
  invalid_fax: 'O número de fax é inválido',
  submit: 'Enviar',
  each_item_superior_zero: 'A quantidade de cada item deve ser superior a 0',
  quantity_edit_success: 'Quantidade alterada com sucesso',
  quantity_edit_failure: 'A quantidade não pôde ser alterada',
  APPROVED: 'Aprovado',
  PENDING: 'Pendente',
  REJECTED: 'Rejeitado',
  //meter
  when_reading_is: 'Quando a leitura do medidor é',
  greater_than: 'Maior que',
  lower_than: 'Menor que',
  value: 'Valor',
  required_value: 'O valor é obrigatório',
  required_trigger_condition: 'A condição é obrigatória',
  wo_trigger_create_success:
    'O gatilho da Ordem de Serviço foi criado com sucesso',
  wo_trigger_create_failure:
    'O gatilho da Ordem de Serviço não pôde ser criado',
  add_wo_trigger: 'Adicionar Gatilho de Ordem de Serviço',
  add_wo_trigger_description:
    'Preencha os campos abaixo para criar e adicionar um gatilho de Ordem de Serviço',
  wo_trigger_edit_success:
    'O gatilho da Ordem de Serviço foi atualizado com sucesso',
  meter_create_success: 'O medidor foi criado com sucesso',
  meter_create_failure: 'O medidor não pôde ser criado',
  meter_edit_failure: 'O medidor não pôde ser editado',
  meter_delete_success: 'O medidor foi excluído com sucesso',
  meter_delete_failure: 'O medidor não pôde ser excluído',
  next_reading_due: 'Próxima Leitura Devida',
  unit_of_measurement: 'Unidade de Medida',
  last_reading: 'Última Leitura',
  enter_meter_name: 'Insira o nome do medidor',
  unit: 'Unidade',
  update_frequency: 'Frequência de Atualização',
  update_frequency_in_days: 'Frequência de Atualização em dias',
  required_meter_name: 'O nome do medidor é obrigatório',
  required_meter_unit: 'A unidade do medidor é obrigatória',
  required_meter_update_frequency:
    'A frequência de atualização do medidor é obrigatória',
  required_asset: 'O ativo é obrigatório',
  add_meter: 'Adicionar Medidor',
  add_meter_description:
    'Preencha os campos abaixo para criar e adicionar um novo medidor',
  edit_meter: 'Editar Medidor',
  edit_meter_description: 'Preencha os campos abaixo para editar o medidor',
  confirm_delete_meter: 'Tem certeza de que deseja excluir este Medidor?',
  upgrade_create_meter: 'Atualize para criar Medidores',
  history: 'Histórico',
  reading_frequency: 'Frequência de Leitura',
  required_reading_value: 'O valor da leitura é obrigatório',
  wo_triggers: 'Gatilhos de Ordem de Serviço',
  add_trigger: 'Adicionar Gatilho',
  meter_details: 'Detalhes do Medidor',
  'noRows.meter.message':
    'As leituras do medidor permitem que você monitore ativos e acione novas ordens de serviço com base em condições definidas',
  'noRows.meter.action': "Pressione o botão '+' para criar um Medidor",
  meter: 'Medidor',
  //upload
  drag_one_file: 'Arraste um único arquivo aqui',
  drag_many_files: 'Arraste e solte arquivos aqui',
  drop_to_start: 'Solte os arquivos para começar o upload',
  invalid_files_type: 'Você não pode fazer upload desses tipos de arquivo',
  you_have_uploaded: 'Você fez upload de',
  upload: 'Upload',
  //vendors_customers
  Vendors_Customers: 'Fornecedores e Contratantes',
  customer_create_success: 'O Contratante foi criado com sucesso',
  customer_create_failure: 'O Contratante não pôde ser criado',
  customer_edit_failure: 'O Contratante não pôde ser editado',
  customer_delete_success: 'O Contratante foi excluído com sucesso',
  customer_delete_failure: 'O Contratante não pôde ser excluído',
  customer_name: 'Nome do Contratante',
  website: 'Website',
  customer_type: 'Tipo de Contratante',
  customer_type_description: 'ex. Encanamento, Elétrica',
  customer_description_description:
    'Descreva o propósito deste contratante em algumas linhas...',
  billing_information: 'Informações de Cobrança',
  address_line_2: 'Linha 2 do Endereço',
  billing_name: 'Nome de Cobrança',
  currency: 'Moeda',
  select_currency: 'Selecionar Moeda',
  required_customer_name: 'O nome do contratante é obrigatório',
  required_phone: 'O número de telefone é obrigatório',
  invalid_website: 'Website inválido',
  billing_address: 'Endereço de Cobrança',
  add_customer: 'Adicionar Contratante',
  add_customer_description:
    'Preencha os campos abaixo para criar e adicionar um novo contratante',
  'noRows.customer.message': 'Contratantes são trabalhadores externos',
  'noRows.customer.action': "Pressione o botão '+' para criar um Contratante",
  type: 'Tipo',
  billing_currency: 'Moeda de Cobrança',
  go_back: 'Voltar',
  confirm_delete_customer:
    'Tem certeza de que deseja excluir este Contratante?',
  //vendor
  vendor_create_success: 'O Fornecedor foi criado com sucesso',
  vendor_create_failure: 'O Fornecedor não pôde ser criado',
  vendor_edit_failure: 'O Fornecedor não pôde ser editado',
  vendor_delete_success: 'O Fornecedor foi excluído com sucesso',
  vendor_delete_failure: 'O Fornecedor não pôde ser excluído',
  required_company_name: 'O nome da empresa é obrigatório',
  vendor_type: 'Tipo de Fornecedor',
  contact_name: 'Nome do Contato',
  add_vendor: 'Adicionar Fornecedor',
  add_vendor_description:
    'Preencha os campos abaixo para criar e adicionar um novo fornecedor',
  confirm_delete_vendor: 'Tem certeza de que deseja excluir este Fornecedor?',
  'noRows.vendor.message':
    'Fornecedores são organizações que fornecem Ativos ou Peças',
  'noRows.vendor.action': "Pressione o botão '+' para criar um Fornecedor",
  vendor_type_description: 'ex. Encanamento, Elétrica',
  //people teams
  role: 'Função',
  edit_user: 'Editar Usuário',
  edit_user_description: 'Preencha os campos abaixo para editar o usuário',
  job_title: 'Cargo',
  invite_users: 'Convidar Usuários',
  bring_people_team: 'Traga novas pessoas para a equipe',
  add_20_users:
    "Você pode adicionar 20 usuários de cada vez pressionando 'tab' ou 'enter' após cada entrada de e-mail. E-mails duplicados e registrados serão removidos ao registrar os usuários solicitados.",
  enter_email: 'Insira o endereço de e-mail',
  users_invite_success: 'Os usuários foram convidados',
  users_invite_failure:
    'Os usuários não podem ser convidados. Verifique a contagem atual de membros da sua assinatura',
  please_type_emails: 'Por favor, digite os e-mails para convidar',
  please_select_role: 'Por favor, selecione uma função',
  invite: 'Convidar',
  team_create_success: 'A Equipe foi criada com sucesso',
  team_create_failure: 'A Equipe não pôde ser criada',
  team_edit_failure: 'A Equipe não pôde ser editada',
  team_delete_success: 'A Equipe foi excluída com sucesso',
  team_delete_failure: 'A Equipe não pôde ser excluída',
  team_name: 'Nome da Equipe',
  people_in_team: 'Pessoas na equipe',
  required_team_name: 'O nome da equipe é obrigatório',
  create_team: 'Criar equipe',
  create_team_description:
    'Você pode adicionar membros da equipe a partir daqui',
  confirm_delete_team: 'Tem certeza de que deseja excluir esta Equipe?',
  overview: 'Visão Geral',
  activity: 'Atividade',
  wo_complete_last_14_days: 'Ordens de serviço concluídas nos últimos 14 dias',
  no_wo_complete_last_14_days:
    'Você não concluiu nenhuma ordem de serviço nas últimas duas semanas',
  ADMIN_name: 'Administrador',
  ADMIN_description:
    'O administrador tem acesso total; incluindo edição, adição, exclusão de ordens de serviço e solicitações',
  LIMITED_ADMIN_name: 'Administrador Limitado',
  LIMITED_ADMIN_description:
    'Os administradores limitados têm o mesmo acesso que o administrador, exceto que não podem visualizar/editar configurações ou adicionar/editar pessoas e equipes. Eles não podem excluir Ordens de Serviço, Ativos, Localizações, Medidores e Ordens de Compra, a menos que tenham criado Contratantes, Categorias e Gatilhos de PM.',
  TECHNICIAN_name: 'Técnico',
  TECHNICIAN_description:
    'Os técnicos podem criar e fechar ordens de serviço, ativos e localizações. Podem editar e excluir apenas o que criaram',
  LIMITED_TECHNICIAN_name: 'Técnico Limitado',
  LIMITED_TECHNICIAN_description:
    'Os técnicos limitados só podem ver as ordens de serviço atribuídas a eles',
  VIEW_ONLY_name: 'Somente Leitura',
  VIEW_ONLY_description:
    'Os usuários somente leitura têm acesso total à visualização, mas não podem editar nada',
  REQUESTER_name: 'Solicitante',
  REQUESTER_description:
    'Os solicitantes só podem enviar solicitações de trabalho e visualizar seu status',
  select_user_role: 'Selecionar função do usuário',
  'noRows.team.message':
    'Equipes ajudam você a gerenciar grupos específicos de pessoas.',
  'noRows.team.action': "Pressione o botão '+' para criar uma equipe.",
  user_details: 'Detalhes do Usuário',
  //files
  file_delete_success: 'O arquivo foi excluído com sucesso',
  file_delete_failure: 'O arquivo não pôde ser excluído',
  uploaded_by: 'Carregado por',
  uploaded_on: 'Carregado em',
  rename: 'Renomear',
  required_files: 'Por favor, faça o upload de pelo menos um arquivo',
  required_file_name: 'Por favor, insira um nome de arquivo',
  add_files: 'Adicionar Arquivos',
  edit_file: 'Editar Arquivo',
  'noRows.file.message': 'Obtenha todos os arquivos em um único lugar',
  'noRows.file.action': "Pressione o botão '+' para fazer upload de um Arquivo",
  upgrade_files:
    'Atualize para usar arquivos em seus Ativos, Ordens de Serviço, Localizações etc...',
  parts_consumption: 'Consumo de Peças',
  requests_analysis: 'Análise de Solicitações',
  //categories,
  category_create_success: 'A Categoria foi criada com sucesso',
  category_create_failure: 'A Categoria não pôde ser criada',
  category_edit_failure: 'A Categoria não pôde ser editada',
  category_delete_success: 'A Categoria foi excluída com sucesso',
  category_delete_failure: 'A Categoria não pôde ser excluída',
  timers: 'Temporizadores',
  costs: 'Custos',
  add_category: 'Adicionar nova categoria',
  add_category_description:
    'Preencha o nome para criar e adicionar uma nova categoria',
  edit_category: 'Editar Categoria',
  edit_category_description: 'Preencha o nome para editar a categoria',
  no_category_action:
    "Pressione o botão '+' para adicionar sua primeira categoria.",
  confirm_delete_category: 'Tem certeza de que deseja excluir esta Categoria?',
  no_category_message:
    'Parece que você ainda não tem nenhuma categoria {{categoryName}}.',
  acquisition_cost: 'Custo de Aquisição',
  //settings
  general_settings: 'Configurações Gerais',
  request_form_configuration: 'Configuração do formulário de solicitação',
  roles: 'Funções',
  checklists: 'Listas de Verificação',
  field_configuration_description:
    'Você pode marcar campos como Opcional, Oculto ou Obrigatório',
  optional: 'Opcional',
  required: 'Obrigatório',
  hidden: 'Oculto',
  creating_wo: 'Criando uma Ordem de Serviço',
  completing_wo: 'Concluindo uma Ordem de Serviço',
  role_edit_failure: 'A função não pôde ser editada',
  edit_role: 'Editar função',
  edit_role_description: 'Preencha os campos abaixo para editar a função',
  external_id: 'ID Externo',
  permissions: 'Permissões',
  create_role_description:
    'Esta função pode fazer tudo o que um Administrador pode fazer no {{brandName}}, mas você pode personalizar algumas permissões importantes abaixo.',
  create_and_edit: 'Criar/Editar',
  to_access: 'Acessar',
  role_delete_success: 'A função foi excluída com sucesso',
  role_delete_failure: 'A função não pôde ser excluída',
  confirm_delete_role:
    'Tem certeza de que deseja excluir permanentemente esta função?',
  users: 'Usuários',
  paid: 'Pago',
  free: 'Grátis',
  role_create_success: 'A função foi criada com sucesso',
  role_create_failure: 'A função não pôde ser criada',
  roles_management: 'Gerenciamento de Funções',
  roles_number: '{{count}} funções',
  create_role: 'Criar Função',
  upgrade_role: 'Atualize para criar função',
  add_role: 'Adicionar nova função',
  add_role_description:
    'Preencha os campos abaixo para criar e adicionar uma nova função',
  parts_and_sets: 'Peças e Conjuntos de Peças',
  upgrade_role_edit: 'Atualize para editar função',
  delete_role: 'Excluir Função',
  upgrade_role_delete: 'Atualize para excluir função',
  create: 'Criar',
  pm_trigger: 'Gatilho de Manutenção Preventiva',
  auto_assign_wo: 'Atribuir automaticamente Ordens de Serviço',
  auto_assign_wo_description:
    'Atribua automaticamente novas ordens de serviço à pessoa que as cria',
  auto_assign_requests: 'Atribuir automaticamente solicitações',
  auto_assign_requests_description:
    'Atribua automaticamente novas ordens de serviço à pessoa que aprova a solicitação',
  disable_closed_wo_notification:
    'Desativar notificações de ordens de serviço fechadas',
  disable_closed_wo_notification_description:
    'Desative notificações quando ordens de serviço fechadas forem atualizadas',
  ask_feedback_wo_closed:
    'Solicitar feedback quando a ordem de serviço for fechada',
  ask_feedback_wo_closed_description:
    'Os usuários são solicitados a dar feedback sobre o trabalho realizado',
  include_labor_in_total_cost: 'Incluir custo de mão de obra no custo total',
  include_labor_in_total_cost_description:
    'Adicione custos de mão de obra ao total quando um usuário registrar o tempo e tiver uma taxa horária armazenada',
  enable_wo_updates_requesters:
    'Ativar atualizações de ordens de serviço para solicitantes',
  enable_wo_updates_requesters_description:
    'Os usuários recebem atualizações para as ordens de serviço que solicitaram',
  language: 'Idioma',
  date_format: 'Formato de data',
  business_type: 'Tipo de negócio',
  general_asset_management: 'Gestão geral de ativos',
  physical_asset_management: 'Gestão de ativos físicos',
  //checklist
  checklist_delete_success: 'A Lista de Verificação foi excluída com sucesso',
  checklist_delete_failure: 'A Lista de Verificação não pôde ser excluída',
  create_checklist: 'Criar Lista de Verificação',
  confirm_delete_checklist:
    'Tem certeza de que deseja excluir esta Lista de Verificação?',
  upgrade_checklist: 'Atualize para usar Listas de Verificação',
  //components
  upgrade_now: 'Atualize Agora',
  total: 'Total',
  sub_task_status: 'Status da Subtarefa',
  text_field: 'Campo de Texto',
  number_field: 'Campo Numérico',
  inspection_check: 'Verificação de Inspeção',
  multiple_choices: 'Múltipla Escolha',
  meter_reading: 'Leitura do Medidor',
  select_user: 'Selecionar Usuário',
  PASS: 'Aprovado',
  FLAG: 'Marcado',
  FAIL: 'Reprovado',
  enter_task_name: 'Insira um nome de tarefa',
  see_details: 'Ver detalhes',
  concerned_asset: 'Ativo Relacionado',
  me: 'Eu',
  remove_blank_tasks: 'Remover tarefas em branco',
  remove_blank_options: 'Remover opções em branco',
  preview: 'Pré-visualização',
  edit_checklist: 'Editar Lista de Verificação',
  add_tasks: 'Adicionar Tarefas',
  use_a_checklist: 'Usar uma lista de verificação',
  select_checklist: 'Selecionar Lista de Verificação',
  save_checklist: 'Salvar Lista de Verificação',
  assign_tasks_description:
    'Atribuir Tarefas Personalizadas para técnicos preencherem',
  select_date: 'Selecionar data',
  task: 'Tarefa',
  checklist: 'Lista de Verificação',
  //analytics
  upgrade_analytics: 'Atualize para ver Análises',
  grouped_by_category: 'Agrupado por Categoria',
  downtime_by_asset: 'Tempo de Inatividade por Ativo',
  downtime_and_costs: 'Tempo de Inatividade e Custos',
  downtime_and_costs_trends: 'Tendências de Tempo de Inatividade e Custos',
  downtimes_trends: 'Tendências de Tempos de Inatividade',
  repair_time_by_asset: 'Tempo de Reparo por Ativo',
  consumed_parts_costs: 'Custos de Peças Consumidas',
  requests_by_priority: 'Solicitações por Prioridade',
  requests_trends: 'Tendências de Solicitações',
  time_spent: 'Tempo Gasto',
  grouped_by_completed_by: 'Agrupado por Concluído por',
  grouped_by_assigned_to: 'Agrupado por Atribuído a',
  grouped_by_priority: 'Agrupado por Prioridade',
  completion_comparison: 'Comparação de Conclusão',
  hours_worked: 'Horas Trabalhadas',
  work_remaining: 'Trabalho Restante',
  wo_status: 'Status da Ordem de Serviço',
  cost_trends: 'Tendências de Custos',
  cost_center: 'Análise de Custo do Ciclo de Vida do Ativo',
  downtime_and_availability: 'Tempo de Inatividade e Disponibilidade',
  incomplete_wo: 'Ordens de Serviço Incompletas',
  the_numbers: 'Os Números',
  hours_and_cost_by_asset: 'Horas e Custo por Ativo',
  completion_comparison_description:
    'Comparação de vários tipos de ordens de serviço concluídas.',
  wo_age_description:
    'A idade da ordem de serviço é definida como o número de dias entre a criação da ordem de serviço (ou solicitação de trabalho) e a conclusão.',
  rav_description:
    'O custo total como % do RAV é igual a (custo das ordens de serviço no ativo / preço de compra)*100. O padrão da indústria é um valor alvo de 3% para esta métrica',
  downtime_and_availability_description:
    'A disponibilidade refere-se à porcentagem em que os ativos estavam em um estado operacional desde sua data de colocação em serviço. O tempo total de inatividade refere-se ao número de eventos de inatividade que ocorreram durante o intervalo de datas especificado',
  total_cost_description:
    'O custo total inclui custo de mão de obra, custo adicional e custo de peças em uma ordem de serviço',
  compliant_wo_description:
    'Ordens de serviço em conformidade são definidas como ordens de serviço que foram concluídas antes da data de vencimento. O tempo de ciclo refere-se ao número de dias até que uma ordem de serviço seja concluída.',
  hours_worked_description:
    'Essas horas correspondem a ordens de serviço que têm uma data de vencimento dentro do intervalo especificado nos filtros.',
  work_remaining_description:
    'Este gráfico mostra o número de ordens de serviço incompletas que estão com vencimento no intervalo de datas especificado nos filtros. As horas estimadas correspondem a essas ordens de serviço individuais.',
  total_downtime_in_hours: 'Tempo Total de Inatividade (horas)',
  downtime_events: 'Eventos de Inatividade',
  percent_downtime: '% de Inatividade',
  meantime_between_failures_in_hours: 'Tempo médio entre falhas (horas)',
  availability_percent: 'Porcentagem de Disponibilidade',
  mean_time_to_repair_in_hours: 'Tempo médio para reparo (horas)',
  average_age: 'Idade Média',
  count: 'Contagem',
  average_cost: 'Custo Médio',
  compliant: 'Conforme',
  average_cycle_time_in_days: 'Tempo Médio de Ciclo (Dias)',
  total_consumption_cost: 'Custo Total de Consumo',
  parts_consumed: 'Peças Consumidas',
  total_cost_as_pct_rav: 'Custo total como % do RAV',
  approved_requests: 'Solicitações Aprovadas',
  pending_requests: 'Solicitações Pendentes',
  cancelled_requests: 'Solicitações Canceladas',
  average_cycle_time: 'Tempo Médio de Ciclo',
  compliance_rate: 'Taxa de Conformidade',
  complete: 'Concluído',
  reactive: 'Reativo',
  recurring: 'Recorrente',
  part_costs: 'Custos de Peças',
  labor_costs: 'Custo de Mão de Obra',
  total_time_spent_in_hours: 'Tempo Total Gasto (Horas)',
  estimated_hours: 'Horas Estimadas',
  total_purchase_price: 'Preço Total de Compra',
  you_have: 'Você tem',
  new_messages: 'novas mensagens',
  //company profile
  company: 'Empresa',
  change_cover: 'Alterar capa',
  required_address: 'O campo de endereço é obrigatório',
  company_details: 'Detalhes da Empresa',
  company_details_description:
    'Gerencie informações relacionadas à sua empresa',
  learn_more: 'Saiba mais',
  //user profile
  profile: 'Perfil',
  email_notifications: 'Notificações por e-mail',
  email_updates_wo:
    'Atualizações por e-mail para Ordens de Serviço e Mensagens',
  email_updates_requests:
    'Atualizações por e-mail para Ordens de Serviço Solicitadas',
  po_emails: 'E-mails de Ordem de Compra',
  required_job_title: 'O campo de cargo é obrigatório',
  required_old_password: 'Por favor, forneça a senha atual.',
  invalid_password: 'A senha é muito curta - deve ter pelo menos 8 caracteres.',
  required_new_password: 'Nenhuma senha fornecida.',
  passwords_must_match: 'As senhas devem corresponder',
  password_change_success: 'Senha alterada com sucesso',
  wrong_password: 'Senha incorreta fornecida',
  current_password: 'Senha Atual',
  new_password: 'Nova Senha',
  confirm_password: 'Confirmar Senha',
  personal_details: 'Detalhes Pessoais',
  personal_details_description:
    'Gerencie informações relacionadas aos seus detalhes pessoais',
  change_password: 'Alterar Senha',
  notification_settings: 'Configurações de Notificações',
  notification_settings_description:
    'Gerencie detalhes relacionados às suas notificações',
  recent_activity: 'Atividade Recente',
  created: 'Criado',
  completed: 'Concluído',
  my_account: 'Minha conta',
  my_company: 'Minha empresa',
  you_are_using_plan:
    'Você está atualmente usando o plano {{planName}}. Ele expirará em {{expiration}}. Atualize agora para obter acesso a mais recursos.',
  upgrade_plan: 'Atualizar Plano',
  //subscription
  plans: 'Planos',
  monthly: 'Mensal',
  annually: 'Anual',
  subscription_change_success: 'A assinatura foi alterada com sucesso',
  invalid_credit_card: 'Número do cartão de crédito inválido',
  required_credit_card: 'O campo do cartão é obrigatório',
  invalid_expiration_month: 'Mês de expiração inválido',
  required_expiration_month: 'O mês de expiração é obrigatório',
  invalid_expiration_year: 'Ano de expiração inválido',
  required_expiration_year: 'O ano de expiração é obrigatório',
  invalid_cvv: 'CVV inválido',
  required_cvv: 'O CVV é obrigatório',
  required_cardholder_name: 'O nome do titular do cartão é obrigatório',
  card: 'Cartão',
  expiration_month: 'Mês de Expiração',
  expiration_year: 'Ano de Expiração',
  cardholder_name: 'Nome do Titular do Cartão',
  seats: 'Assentos',
  cost_per_seat: 'Custo por assento',
  your_payment_secure: 'Seus dados de pagamento são criptografados e seguros.',
  plan: 'Plano',
  current_plan: 'Plano Atual',
  number_users_who_will_use_grash:
    'Número de usuários que usarão o {{shortBrandName}}',
  admin_role: 'Admin',
  technical_role: 'Técnico',
  limited_technical_role: 'Técnico Limitado',
  requester_role: 'Solicitante',
  view_only_role: 'Somente Leitura',
  how_will_you_be_billed: 'Como você gostaria de ser cobrado?',
  which_plan_fits_you: 'Qual plano se encaixa melhor em você?',
  per_user_month: 'por usuário/mês',
  per_user_year: 'por usuário/ano',
  you_will_be_charged: 'Você será cobrado',
  proceed_to_payment: 'Prosseguir para o Pagamento',
  pay_only_for_roles:
    'Pague apenas por usuários <strong>Admin</strong>, <strong>Técnico</strong> e <strong>Técnico Limitado</strong>, e use <strong>Solicitante</strong>, <strong>Somente Leitura</strong> ilimitados gratuitamente',
  checkout_our: 'Confira nossa',
  pricing_page: 'Página de Preços',
  for_more_details: 'para mais detalhes',
  users_count_display: '{{count}} Usuários',
  monthly_adverb: 'mensalmente',
  yearly_adverb: 'anualmente',
  features: 'Recursos',
  checkout: 'Finalizar Compra',
  checkout_description: 'Preencha os campos abaixo',
  per_month: 'por mês',
  per_year: 'por ano',
  recover_password_description:
    'Insira o e-mail usado para o registro para redefinir sua senha.',
  send_me_new_password: 'Envie-me uma nova senha',
  want_to_sign_in_again: 'Quer tentar entrar novamente?',
  check_mails_for_instructions:
    'Verifique seu e-mail para obter mais instruções',
  pdf_report: 'Relatório PDF',
  HIGH: 'Alto',
  MEDIUM: 'Médio',
  LOW: 'Baixo',
  NONE: 'Nenhum',
  import: 'Importar',
  start_import_process: 'Iniciar Processo de Importação',
  import_data: 'Importar Dados',
  set_header: 'Definir Cabeçalho',
  match_columns: 'Corresponder Colunas',
  review: 'Revisar',
  done: 'Concluído',
  no_match_yet: 'Nenhuma correspondência ainda',
  select: 'Selecionar...',
  matched_to_field: 'Correspondente a {{field}}',
  next: 'Próximo',
  not_enough_rows: 'Não há linhas suficientes no arquivo',
  there_are_duplicates: 'Há duplicatas: {{duplicates}}',
  assigned_by: 'Atribuído por',
  percent_rows_have_value: '{{percent}}% das linhas têm valor',
  match_at_least_column: 'Corresponda pelo menos uma coluna',
  to_import: 'Importar',
  required_match: 'A correspondência de {{field}} é obrigatória',
  archived: 'Arquivado',
  import_wo_success:
    '{{created}} Ordens de Serviço foram criadas e {{updated}} foram atualizadas',
  to_export: 'Exportar',
  filters: 'Filtros',
  more_filters: 'Mais Filtros',
  customer: 'Contratante',
  to: 'para',
  dates: 'Datas',
  start: 'Início',
  end: 'Fim',
  longitude: 'Longitude',
  latitude: 'Latitude',
  ALL: 'Todos',
  REACTIVE: 'Reativo',
  REPEATING: 'Preventivo',
  import_location_success:
    '{{created}} Localizações foram criadas e {{updated}} foram atualizadas',
  import_part_success:
    '{{created}} Peças foram criadas e {{updated}} foram atualizadas',
  import_meter_success:
    '{{created}} Medidores foram criados e {{updated}} foram atualizados',
  import_asset_success:
    '{{created}} Ativos foram criados e {{updated}} foram atualizados',
  wo_calendar: 'Calendário de Ordens de Serviço',
  month: 'Mês',
  week: 'Semana',
  day: 'Dia',
  agenda: 'Agenda',
  previous: 'Anterior',
  today: 'Hoje',
  to_filter: 'Filtrar',
  'noRows.asset.message':
    'Ativos são recursos nos quais sua empresa pode intervir',
  'noRows.asset.action': "Pressione o botão '+' para criar um novo Ativo.",
  reset_filters: 'Redefinir Filtros',
  toggle_menu: 'Alternar Menu',
  no_results: 'Nenhum resultado encontrado',
  an_error_occured: 'Ocorreu um erro.',
  density: 'Densidade',
  compact: 'Compacto',
  standard: 'Padrão',
  comfortable: 'Confortável',
  columns: 'Colunas',
  select_columns: 'Selecionar colunas',
  show_filters: 'Mostrar filtros',
  hide_filters: 'Ocultar filtros',
  search_placeholder: 'Pesquisar…',
  search: 'Pesquisar',
  clear: 'Limpar',
  download_as_csv: 'Baixar como CSV',
  print: 'Imprimir',
  download_as_excel: 'Baixar como Excel',
  find_column: 'Encontrar coluna',
  column_title: 'Título da coluna',
  reorder_column: 'Reordenar coluna',
  show_all: 'Mostrar tudo',
  hide_all: 'Ocultar tudo',
  add_filter: 'Adicionar filtro',
  logic_operator: 'Operador lógico',
  operator: 'Operador',
  and: 'E',
  or: 'Ou',
  filter_value: 'Valor do filtro',
  contains: 'contém',
  equals: 'igual a',
  starts_with: 'começa com',
  ends_with: 'termina com',
  is: 'é',
  is_not: 'não é',
  is_after: 'é depois',
  is_on_or_after: 'é em ou depois',
  is_before: 'é antes',
  is_on_or_before: 'é em ou antes',
  is_empty: 'está vazio',
  is_not_empty: 'não está vazio',
  is_any_of: 'é qualquer um de',
  any: 'qualquer',
  true_text: 'verdadeiro',
  false_text: 'falso',
  menu: 'Menu',
  show_columns: 'Mostrar colunas',
  hide: 'Ocultar',
  unsort: 'Desordenar',
  sort_by_ASC: 'Ordenar por ASC',
  sort_by_DESC: 'Ordenar por DESC',
  sort: 'Ordenar',
  total_rows: 'Total de Linhas:',
  yes: 'Sim',
  no: 'Não',
  more: 'Mais',
  to_group: 'Agrupar',
  see_children: 'ver filhos',
  hide_children: 'ocultar filhos',
  expand: 'Expandir',
  collapse: 'Recolher',
  detail_panel_toggle: 'Alternar painel de detalhes',
  cancel_subscription: 'Cancelar Assinatura',
  resume_subscription: 'Retomar Assinatura',
  confirm_cancel_subscription:
    'Tem certeza de que deseja cancelar a assinatura?',
  workflows: 'Fluxos de Trabalho',
  create_workflow: 'Criar Fluxo de Trabalho',
  if: 'Se',
  and_optional: 'E (Opcional)',
  then: 'Então',
  workflow_description:
    'Crie fluxos de trabalho personalizados tão fácil quanto Se, E, Então. Economize tempo e atribua facilmente suas ordens de serviço automaticamente através de fluxos de trabalho para personalizar o {{shortBrandName}} para a maneira como sua equipe opera.\nTodos os planos podem criar até 1 fluxo de trabalho personalizado. Para adicionar fluxos de trabalho adicionais, atualize para o nosso plano Business',
  CREATE_PURCHASE_ORDER: 'Criar uma Ordem de Compra',
  PART_IS: 'A Peça é',
  QUANTITY_INFERIOR: 'A quantidade é inferior a',
  ASSIGN_VENDOR: 'Atribuir o fornecedor',
  ASSIGN_CATEGORY: 'Atribuir a categoria',
  APPROVE: 'Aprovar',
  REJECT: 'Rejeitar',
  SEND_REMINDER_EMAIL: 'Enviar e-mail de lembrete',
  VENDOR_IS: 'O fornecedor é',
  CATEGORY_IS: 'A categoria é',
  STATUS_IS: 'O status é',
  DUE_DATE_BETWEEN: 'A data de vencimento está entre',
  DUE_DATE_AFTER: 'A data de vencimento é após',
  ASSIGN_PRIORITY: 'Atribuir a prioridade',
  ASSIGN_ASSET: 'Atribuir o Ativo',
  ASSIGN_LOCATION: 'Atribuir a Localização',
  ASSIGN_USER: 'Atribuir o usuário',
  ASSIGN_TEAM: 'Atribuir a equipe',
  ADD_CHECKLIST: 'Adicionar lista de verificação',
  PRIORITY_IS: 'A prioridade é',
  ASSET_IS: 'O ativo é',
  LOCATION_IS: 'A localização é',
  USER_IS: 'O usuário é',
  TEAM_IS: 'A equipe é',
  CREATED_AT_BETWEEN: 'Foi criado entre',
  TITLE_CONTAINS: 'O título contém',
  CREATE_REQUEST: 'Criar uma solicitação',
  CREATE_WORK_ORDER: 'Criar uma Ordem de Serviço',
  SET_ASSET_STATUS: 'Definir status do ativo',
  NAME_IS: 'O nome é',
  NAME_CONTAINS: 'O nome contém',
  VALUE_IS: 'O valor é',
  VALUE_CONTAINS: 'O valor contém',
  NUMBER_VALUE_SUPERIOR: 'O valor é superior a',
  NUMBER_VALUE_INFERIOR: 'O valor é inferior a',
  WORK_ORDER_CREATED: 'Uma Ordem de Serviço foi criada',
  WORK_ORDER_CLOSED: 'Uma Ordem de Serviço foi fechada',
  WORK_ORDER_ARCHIVED: 'Uma Ordem de Serviço foi arquivada',
  REQUEST_CREATED: 'Uma solicitação foi criada',
  REQUEST_APPROVED: 'Uma solicitação foi aprovada',
  REQUEST_REJECTED: 'Uma solicitação foi rejeitada',
  PURCHASE_ORDER_CREATED: 'Uma ordem de compra foi criada',
  PURCHASE_ORDER_UPDATED: 'Uma ordem de compra foi atualizada',
  TASK_UPDATED: 'Uma tarefa foi atualizada',
  PART_UPDATED: 'Uma peça foi atualizada',
  add_condition: 'Adicionar condição',
  workflow_creation_success: 'Fluxo de trabalho criado com sucesso',
  workflow_creation_failure:
    'A criação do fluxo de trabalho não foi bem-sucedida',
  action_value_missing: 'O valor da ação está faltando',
  condition_value_missing: 'Um valor de condição está faltando',
  workflow_edit_success: 'O fluxo de trabalho foi atualizado com sucesso',
  workflow_edit_failure: 'O fluxo de trabalho não pôde ser editado',
  workflow_delete_success: 'O fluxo de trabalho foi excluído com sucesso',
  workflow_delete_failure: 'O fluxo de trabalho não pôde ser excluído',
  confirm_delete_workflow:
    'Tem certeza de que deseja excluir este fluxo de trabalho?',
  click_here: 'Clique aqui',
  verify_email_title: 'Verificar E-mail',
  verify_email_description:
    'Um e-mail de verificação foi enviado para você. Verifique a pasta de spam se não o vir na sua caixa de entrada.',
  upgrade: 'Atualizar',
  downgrade: 'Rebaixar',
  upgrade_description:
    'Você acabou de atualizar seu plano de assinatura. Você precisa habilitar os usuários desabilitados que podem usar o {{shortBrandName}}. Você só pode fazer isso uma vez para a assinatura atual. Por favor, escolha com cuidado',
  enable_users: 'Habilitar usuários',
  max_users_description: 'Você pode habilitar até {{maxUsers}} usuários',
  downgrade_description:
    'Você acabou de rebaixar seu plano de assinatura. Você precisa desabilitar alguns usuários para prosseguir. Você só pode fazer isso uma vez para a assinatura atual. Por favor, escolha com cuidado',
  disable_users: 'Desabilitar usuários',
  min_users_description:
    'Você deve desabilitar no mínimo {{minUsers}} usuários',
  downgrade_description_no_owner:
    'Sua empresa acabou de rebaixar seu plano de assinatura. O proprietário da empresa precisa desabilitar alguns usuários antes que você possa prosseguir',
  past_due: 'Vencido',
  due_date_delay: 'Atraso na Data de Vencimento',
  due_date_delay_description: 'Atraso na data de vencimento em dias',
  days_count: '{{days}} dias',
  trigger_configuration: 'Configuração do Gatilho',
  WORK_ORDER_feature: 'Ordens de Serviço',
  REQUEST_feature: 'Solicitações de Trabalho',
  PART_feature: 'Gestão de Peças',
  MOBILE_APP_feature: 'Aplicativo Móvel',
  WORK_ORDER_HISTORY_feature: 'Histórico de Ordens de Serviço',
  PREVENTIVE_MAINTENANCE_feature: 'Manutenção Preventiva',
  CHECKLIST_feature: 'Listas de Verificação',
  FILE_feature: 'Uploads de Arquivos',
  PURCHASE_ORDER_feature: 'Ordens de Compra',
  METER_feature: 'Leituras de Medidores',
  REQUEST_CONFIGURATION_feature: 'Configuração do Formulário de Solicitação',
  ADDITIONAL_TIME_feature: 'Acompanhamento Avançado de Tempo',
  ADDITIONAL_COST_feature: 'Acompanhamento Avançado de Custos',
  ANALYTICS_feature: 'Análises e Relatórios',
  REQUEST_PORTAL_feature: 'Portal de Solicitações',
  SIGNATURE_feature: 'Assinaturas',
  ROLE_feature: 'Funções Personalizadas',
  WORKFLOW_feature: 'Automação de Fluxo de Trabalho',
  API_ACCESS_feature: 'Acesso à API',
  WEBHOOK_feature: 'Webhooks',
  add_new_option: 'Adicionar nova Opção',
  edit_company: 'Editar empresa',
  fill_fields_below: 'Preencha os campos abaixo',
  IMPORT_CSV_feature: 'Importação de CSV',
  no_import_access: 'Atualize seu plano para importar de arquivos CSV, Excel',
  members: 'Membros',
  assign_user: 'Atribuir Usuário',
  assign_asset: 'Atribuir Ativo',
  required_files_on_completion:
    'Arquivos são necessários na conclusão da Ordem de Serviço',
  required_tasks_on_completion: 'As tarefas devem ser concluídas',
  required_labor_on_completion: 'Você deve registrar o tempo',
  required_part_on_completion: 'Nenhuma peça foi usada nesta Ordem de Serviço',
  required_cost_on_completion:
    'Nenhuma informação de custo fornecida nesta Ordem de Serviço',
  estimated_hours_in_text: '{{hours}} horas estimadas',
  required_part_name: 'O nome da peça é obrigatório',
  asset_update_failure: 'O ativo não pôde ser editado',
  terms_of_service: 'Termos de serviço',
  privacy_policy: 'Política de privacidade',
  last_login: 'Último Login',
  not_enough_part: 'Não há quantidade suficiente desta peça',
  remove_blank_meter_tasks: 'Remover tarefas do tipo medidor sem um medidor',
  checklist_update_failure: 'A lista de verificação não pôde ser editada',
  contact_us: 'Contate-nos',
  simplify_wo: 'Simplificar Ordens de Serviço no aplicativo móvel',
  simplify_wo_description:
    'Ocultar controles de tempo, custos e peças nos detalhes da Ordem de Serviço ao usar o aplicativo móvel',
  account_deletion: 'Exclusão de conta',
  switch_account: 'Trocar conta',
  switch_to_super_user: 'Trocar para super administrador',
  switch_account_description: 'Por favor, escolha uma conta para prosseguir',
  put_location_in_map: 'Colocar localização no mapa',
  confirm_disable_user:
    'Tem certeza de que deseja desabilitar {{user}}? Você só poderá habilitá-lo após um mês',
  user_disabled_success: 'Usuário desabilitado com sucesso',
  disable: 'Desabilitar',
  manufacturer: 'Fabricante',
  power: 'Potência',
  import_error: 'A importação não foi bem-sucedida',
  request_upgrade: 'Solicitar atualização',
  operation_success: 'A operação foi um sucesso',
  CANCELLED: 'Rejeitado',
  uptime_hours: 'Tempo de Atividade (h)',
  downtime_hours: 'Tempo de Inatividade (h)',
  mark_all_as_seen: 'Marcar todos como vistos',
  estimation_accuracy_ratio: 'Taxa de precisão da estimativa',
  download_template: 'Baixar modelo',
  pareto_by_total_price: 'Pareto por preço total',
  cumulative_percent: 'Porcentagem cumulativa',
  part_consumption_by_asset: 'Consumo de peças por ativo',
  grouped_by_wo_category: 'Agrupado por categoria de ordem de serviço',
  resolution_rate: 'Taxa de resolução',
  resolved: 'Resolvido',
  average: 'Média',
  documentation: 'Documentação',
  days_before_pm_notification:
    'Notificações pré-ordem de serviço para as agendadas',
  estimated_start_date: 'Data de início estimada',
  no_file_linked_to_wo: 'Nenhum arquivo vinculado a esta ordem de serviço',
  add_file: 'Adicionar arquivo',
  try_for_free: 'Experimente gratuitamente',
  choose_your_plan: 'Escolha seu plano',
  STARTER_description:
    'Equipes que desejam construir uma manutenção preventiva eficiente e forte através do status da máquina e visibilidade da mão de obra.',
  PROFESSIONAL_description:
    'Departamentos que precisam aproveitar insights e análises para impulsionar o crescimento e a produtividade da manutenção.',
  BUSINESS_description:
    'Organizações prontas para capturar dados de manutenção e operações para gerenciar várias localizações e personalização do sistema.',
  book_demo: 'Agendar uma demonstração',
  request_pricing: 'Solicitar preços para mais informações',
  Reports: 'Informação',
  'Custom dashboard built using the included components':
    'Placa personalizada construída usando os componentes incluídos',
  Export: 'Exportar',
  'Last year': 'Ano passado',
  Expenses: 'Contas',
  Statistics: 'Estatística',
  General: 'Em geral',
  Calendar: 'Calendário',
  Mailbox: 'Caixas de correio',
  Dashboards: 'Painéis',
  Analytics: 'Analítico',
  Monitoring: 'Ouvir',
  Tasks: 'Tarefas',
  Applications: 'Aplicações',
  Users: 'Usuários',
  'List All': 'Todos',
  'User Profile': 'Perfil de usuário',
  Login: 'Conectar',
  Register: 'Registro',
  'Recover Password': 'Recuperar senha',
  Status: 'Estado',
  'Error 404': 'Erro 404',
  'Error 500': 'Erro 500',
  'Coming Soon': 'Futuro',
  Maintenance: 'Manutenção',
  Overview: 'Avançar',
  Documentation: 'Documentação',
  Welcome: 'Bem-vindo',
  Help: 'Ajuda',
  'Features tour': 'Visita de recursos',
  'Getting started guide': 'Guia da casa',
  'Contact support': 'Entre em contato com o suporte',
  Version: 'Versão',
  Search: 'Procurar',
  Notifications: 'Notificações',
  Settings: 'Parâmetros',
  'Language Switcher': 'Seletor de idiomas',
  'Sign out': 'Desconexão',
  'Change Theme': 'Altere o assunto',
  'View all notifications': 'Mostre todas as notificações',
  rate: 'Freqüência',
  OPERATIONAL: 'Operacional',
  DOWN: 'Fora de serviço',
  MODERNIZATION: 'Modernização',
  STANDBY: 'Em espera',
  INSPECTION_SCHEDULED: 'Inspeção agendada',
  COMMISSIONING: 'Comissionamento',
  EMERGENCY_SHUTDOWN: 'Desligamento de emergência',
  select_asset_status: 'Selecione o status do ativo',
  asset_status: 'Status do ativo',
  ui_configuration: 'Configuração da interface',
  password_leave_empty_if_you_dont_want_to_change:
    'Senha - deixe em branco se não quiser alterá-la',
  upgrade_request_success:
    'Solicitação de upgrade recebida! Entraremos em contato em breve com os detalhes de pagamento',
  continue_with_sso: 'Continuar com o SSO',
  see_live_demo: 'Ver demonstração ao vivo',
  days: 'Dias',
  weeks: 'Semanas',
  months: 'Meses',
  years: 'Anos',
  based_on: 'Com base em',
  scheduled_date: 'Data programada',
  on: 'Em',
  required_days_of_week: 'Dias da semana obrigatórios',
  'schedule.daily_one': 'A cada {{count}} dia',
  'schedule.daily_other': 'A cada {{count}} dias',
  'schedule.weekly_one': 'A cada {{count}} semana em {{days}}',
  'schedule.weekly_other': 'A cada {{count}} semanas em {{days}}',
  'schedule.monthly_one': 'A cada {{count}} mês',
  'schedule.monthly_other': 'A cada {{count}} meses',
  'schedule.yearly_one': 'A cada {{count}} ano',
  'schedule.yearly_other': 'A cada {{count}} anos'
};

export default ptBRJSON;
